window.mainNavigation = {
    $mainWrapper: null,
    $mainNav: null,
    $mainNavBurger: null,
    $mainNavBurgerIcon: null,
    $mainNavClose: null,
    $mainNavLevel1WithSubLevel: null,

    init: function($wrapper) {
        this.$mainWrapper = $wrapper;
        this.$mainNav = this.$mainWrapper.querySelector(".header__nav");
        this.$mainNavBurger = this.$mainWrapper.querySelector(".header__nav--open");
        this.$mainNavBurgerIcon = this.$mainWrapper.querySelector(".header__burger");
        this.$mainNavClose = this.$mainWrapper.querySelector(".header__nav--close");
        this.$mainNavLevel1WithSubLevel = this.$mainWrapper.querySelectorAll(".level1__collapse");
        this.toggleNavLevel1();
        this.toggleNavLevel1ToLevel2();
        this.closeNav();
    },

    /**
     * Toggle Level1 Navigation
     */
    toggleNavLevel1: function() {
        this.$mainNavBurger.addEventListener("click", function(){
            window.mainNavigation.$mainNav.classList.toggle("header__nav--toggled");
            window.mainNavigation.$mainNavBurgerIcon.classList.toggle("header__burger--active");
        });
    },

    /**
     * Toggle Level2 Navigation Elements to show up
     */
    toggleNavLevel1ToLevel2: function() {
        this.$mainNavLevel1WithSubLevel.forEach(function(item) {
            item.addEventListener("click", function() {
                if(this.parentNode.classList.contains("level1--toggled")) {
                    window.mainNavigation.closeAllLevels();
                }
                else {
                    window.mainNavigation.closeAllLevels();
                    this.parentNode.classList.toggle("level1--toggled");
                    this.parentNode.querySelector(".level2").classList.toggle("level2--toggled");
                }
            });
        });
    },

    /**
     * Close Menu Navigation
     */
    closeNav: function() {
        this.$mainNavClose.addEventListener("click", function() {
            window.mainNavigation.closeAllLevels();
            window.mainNavigation.$mainNav.classList.toggle("header__nav--toggled");
            window.mainNavigation.$mainNavBurgerIcon.classList.toggle("header__burger--active");
        });
    },

    /**
     * Close All active Level2 Elements in Navigation
     */
    closeAllLevels: function() {
        let $openLevel2 = this.$mainWrapper.querySelector(".level1--toggled");

        if($openLevel2) {
            $openLevel2.querySelector(".level2").classList.toggle("level2--toggled");
            $openLevel2.classList.toggle("level1--toggled");
        }
    }
};
